<template>
  <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Beheer uw gebruikers</h4>
            <p>Zoek gebruikers en selecteer deze om te bewerken.</br> Om een nieuwe gebruiker aan te maken kunt u het plus icoontje aanklikken.</p>
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">      
      <v-flex xs12 md12 lg6 xl5 pt-2>          
          <v-widget title="Gebruikers beheren" class="" title-text-color="" v-if="!selectedUser">
            <v-btn fab dark  color="accent" slot="button-top-right" @click="newUser()">
                <v-icon dark>add</v-icon>
            </v-btn>  
            <v-layout slot="widget-content" pt-4 >                                                
                <v-flex xs12>                                         
                    <v-text-field
                        @keyup="search(vm)"
                        v-model="searchMixin.searchText"
                        prepend-inner-icon="fas fa-search"
                        dense
                        label="Zoek een gebruiker"
                        solo>                    
                    </v-text-field>
                    <v-pagination v-if="userPagination.count > 0"
                        v-model="userPagination.current_page"
                        :length="userPagination.total_pages"                           
                        @input="loadPage">
                    </v-pagination>                      
                    <v-list two-line>
                        <v-list-tile v-for="user in users" :key="user.id" @click="selectUser(user)">
                            <v-list-tile-avatar>
                                <dd-avatar :user="user"></dd-avatar>
                            </v-list-tile-avatar>            
                            <v-list-tile-content>
                                <v-list-tile-title v-html="`${user.person.lastName}, ${user.person.firstName}`"></v-list-tile-title>                                
                                <v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>                                
                            </v-list-tile-content>
                            <v-chip v-if="!user.active" color="red" dark label small outline>inactief</v-chip>
                        </v-list-tile>                       
                    </v-list>            
                    <v-pagination v-if="userPagination.count > 0"             
                        v-model="userPagination.current_page"
                        :length="userPagination.total_pages"                           
                        @input="loadPage">
                    </v-pagination>                            
                </v-flex>                                
            </v-layout>
        </v-widget>
        <!-- USER ENTRY FORM  -->
        <v-widget :title="userEditTitle" class="" title-text-color="" v-if="selectedUser">
            <v-btn fab dark  color="accent" slot="button-top-right" @click="selectedUser=false; reset()">
                <v-icon dark>arrow_back</v-icon>
            </v-btn>  
            <v-layout slot="widget-content" pt-4 >                                                
                <v-flex xs12>     
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>                    
                        <v-layout row mb-4>
                            <v-flex xs8 >
                                <dd-avatar :user="selectedUser" size="extra-large"></dd-avatar>
                            </v-flex>  
                            <v-flex xs4 justify-self-end align-self-end>                                                    
                                <v-switch 
                                    :label="userActive"
                                    v-model="selectedUser.active">
                                </v-switch>
                            </v-flex>                                                                              
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12 px-2>                            
                                <v-text-field
                                v-model="selectedUser.email"                     
                                label="Gebruikersnaam (e-mail)"
                                :rules="[form.rules.email]"    
                                required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 px-2>
                                <v-text-field
                                    label="Wachtwoord"
                                    v-model="selectedUser.password"    
                                    @click:append="form.showPassword = !form.showPassword"        
                                    :rules="[form.rules.password]"                                                                                 
                                    :append-icon="form.showPassword ? 'visibility_off':'visibility'"
                                    :type="form.showPassword ? 'text':'password' " 
                                    :hint="form.passwordHint"                                                                
                                    required>
                                </v-text-field>                                        
                            </v-flex>
                            <v-flex xs12 md6 px-2>                                                    
                                <v-text-field
                                v-model="selectedUser.firstName"                     
                                label="Voornaam"
                                :rules="[form.rules.firstName]"                                                                   
                                required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 px-2>                        
                                <v-text-field
                                v-model="selectedUser.lastName"                     
                                label="Achternaam"                                
                                :rules="[form.rules.lastName]"                                   
                                required>
                                </v-text-field>     
                            </v-flex>
                            <v-flex xs12 md6 px-2>                    
                                <v-text-field
                                v-model="selectedUser.street"                     
                                label="Straat"
                                :rules="[form.rules.street]"                                                             
                                required>                                
                                </v-text-field>      
                            </v-flex>
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.houseNumber"   
                                :rules="[form.rules.houseNumber]"                                  
                                label="Huisnummer">
                                </v-text-field>                                                                  
                            </v-flex>
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.zipcode" 
                                :rules="[form.rules.zipcode]"                            
                                label="Postcode">
                                </v-text-field>               
                            </v-flex>                                
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.city"                     
                                label="Plaats"
                                :rules="[form.rules.city]"                                                                                             
                                required>
                                </v-text-field>               
                            </v-flex>        
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.phoneNumber"                     
                                label="Telefoonnummer">
                                </v-text-field>               
                            </v-flex>                 
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.creationDate"                     
                                label="Aangemaakt op"
                                readonly
                                disabled>                                
                                </v-text-field>               
                            </v-flex>        
                            <v-flex ml-2 mb-2 v-if="userRoles.length == 0" row xs12>     
                                <h4>Geen gebruikersrollen aanwezig</h4>
                            </v-flex>                                          
                            <v-flex v-else row xs12>     
                                <v-flex xs12 ml-2 mt-2> 
                                    <h4>Gebruiker heeft rollen: </h4>
                                </v-flex>             
                                <v-layout row wrap ml-2>
                                    <v-flex></v-flex>
                                    <v-flex md6 xs12 v-for="role in editableUserRoles" :key="role.id">
                                        <v-checkbox :label="role.name" v-model="selectedUserRoles[ String(role.id)]" value="value"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex row xs12>                  
                                <v-layout >
                                    <v-btn                          
                                        color=""                      
                                        @click="reset(currentPage)"> 
                                        annuleren
                                    </v-btn>                                                                                                         
                                    <v-spacer></v-spacer>                                         
                                    <v-btn                                                
                                        :disabled="!valid"
                                        color="success"
                                        @click="saveForm">
                                        Opslaan
                                    </v-btn>                        
                                </v-layout>                                                                    
                            </v-flex>  
                        </v-layout>                                     
                  </v-form>
                </v-flex>
            </v-layout>
        </v-widget>
      </v-flex>
    </v-layout>   
  </v-layout>
</template>
<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import VWidget from "../../components/global/VWidget"
    import TopInfoPanel from "../../components/global/TopInfoPanel"
    import DdAvatar from "../../components/global/DdAvatar"    
    import Notification from "../../components/global/Notification"
    import SearchWithPagerMxin from "../../plugins/mixins/SearchWithPagerMixin"

    export default {
        mixins:[SearchWithPagerMxin],
        data() {            
            return {            
                selectedUserRoles:[],          
                valid:true,                                          
                selectedUser: null,
                form:{
                    wantToSave:false, // this is needed so form wont be validated while typing
                    showPassword:false,
                    passwordHint:"Wachtwoord moet minimaal 6 karakters, een hoofdletter en een cijfer of teken bevatten",
                    rules:{
                        email:(value) => {
                            // only validate on save not during typing
                            if(!this.form.wantToSave)
                                return true;
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            return pattern.test(value) || "ongeldig email adres"
                        },
                        password:(value) => {
                            // only validate on save not during typing 
                            if(!this.form.wantToSave)
                                return true;               
                            
                            // if selected user id is set and password is empty always return true, it is allowed (it will not be saved)
                            if(this.selectedUser.id && !this.selectedUser.password){
                                return true;
                            }
                            let errorText = this.form.passwordHint;
                            let valid = true;

                            if(value && value.length < 6)
                                return errorText
                            let hasNumber        = /\d/
                            let hasSpecialChar   = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/
                            let hasCapitolLetter = /[A-Z]/
                            
                            // needs one number or one special char 
                            return ((hasNumber.test(value) || hasSpecialChar.test(value)) && hasCapitolLetter.test(value))  || errorText
                        },
                        firstName:(value) => {
                            if(!this.form.wantToSave)
                                return true;  
                            return value ? true :  "Voornaam is verplicht"
                        },
                        lastName:(value) => {
                            if(!this.form.wantToSave)
                                return true;  
                            return value ? true :  "Achternaam is verplicht"
                        },                        
                        street:(value) => {
                            if(!this.form.wantToSave)
                                return true;  
                            return value ? true :  "Straat is verplicht"
                        },
                        city:(value) => {
                            return value ? true :  "Plaats is verplicht"
                        },
                        zipcode:(value) => {
                            return value ? true : "Geen geldige postcode"    
                        },
                        houseNumber:(value) => {
                            return value ? true :  "Huisnummer is verplicht"
                        }                          
                    }                    
                }
            }
        },
        computed: {
            ...mapGetters({
                users: types.USERS,
                currentUser: types.CURRENT_USER,
                userRoles: types.USER_ROLES,
                userPagination: types.USERS_PAGINATION
            }),
            editableUserRoles(){
                let isSysAdmin= this.$currentUserHasRole('system_administrator')
                let roles=[] 
                
                this.userRoles.forEach((role) => {                    
                    if(role.name != 'system_administrator' || (role.name == 'system_administrator' && isSysAdmin)){
                        roles.push(role)
                    }
                })
                return roles
            },
            userEditTitle(){
                return (this.selectedUser && this.selectedUser.id) ? "Gebruiker aanpassen" : "Gebruiker toevoegen"
            },
            userActive(){
                return this.selectedUser.active ? "Account actief" : "Account inactief"
            }
        },
        methods: {
            saveForm(){
                let vm = this
                this.form.wantToSave=true;
                if (this.$refs.form.validate()) {
                    this.form.wantToSave=false;                                                                   
                    this.$store.dispatch(types.SAVE_USER, {data:this.selectedUser} )
                        .then((res) => {                                                                                    
                            // on succesfull user store, prepare sync roles for user
                            let userId = res.data.id;
                            let selectedRoles = [];
                            for(let i in this.selectedUserRoles){
                                if(this.selectedUserRoles[i] == "value"){
                                    selectedRoles.push(i)
                                }
                            }

                            // store sync_user_roles
                            this.$store.dispatch(types.SYNC_USER_ROLES, {userId:userId, roles:selectedRoles} ).then((res) => {                                               
                                let text = "Gebruiker "+this.selectedUser.firstName+" "+this.selectedUser.lastName+" succesvol ";
                                text += this.selectedUser.id ?  "aangepast" : "aangemaakt";
                                this.$notify(text, {color:"green",duration:1000} );

                                // reload current user if current user is the one beeing updated
                                if(vm.currentUser.id == vm.selectedUser.id){
                                    vm.$store.dispatch(types.LOAD_CURRENT_USER)
                                }
                                this.reset(this.currentPage);                         
                            })                        
                        })
                        .catch((res) => {
                            if(res == "PASSWORD_GIVEN_INVALID"){
                                this.$notify("Wachtwoord niet valide. "+this.form.passwordHint, {color:"red",duration:1000} );
                            }
                            else{
                                this.$notify("Aanmaken gebruiker mislukt", {color:"red",duration:1000} );
                            }
                        })                
                }                
            },
            newUser(){
                let newUser = {
                    id:false,
                    email:"",
                    password:"",
                    firstName:"",
                    lastName:"",
                    street:"",
                    houseNumber:"",
                    zipcode:"",
                    city:"",
                    phoneNumber:"",
                    active:true                    
                }                

              this.selectedUser = newUser;
                
            },
            selectUser(user){
                let edit = {};
                                
                edit.id           = user.id
                edit.email        = user.email
                edit.firstName    = user.person.firstName
                edit.lastName     = user.person.lastName
                edit.lastChange   = user.lastChange 
                edit.creationDate = user.creationDate
                edit.street       = user.person.address.street
                edit.houseNumber  = user.person.address.houseNumber
                edit.city         = user.person.address.city
                edit.zipcode      = user.person.address.zipcode
                edit.phoneNumber  = user.person.phoneNumber
                edit.active       = user.active
                
                if(user.avatar)
                    edit.avatar       = user.avatar ? user.avatar : null;
                
                this.selectedUser = edit

                user.roles.forEach((role) => {
                    this.selectedUserRoles[String(role.id)] = "value";
                })
            },
            reset(toPage=1){                
                     
                this.selectedUserRoles=[]
                this.selectedUser = null
                this.loadPage(toPage)
            }
        },
        mounted(){    
            // configure mixin
            this.searchMixin.payloadData     = {}
            this.searchMixin.payloadIncludes = "person.address,avatar,roles"
            this.searchMixin.searchStore     = types.USERS_SEARCH
            this.searchMixin.defaultStore    = types.USERS

            this.reset()
            this.$store.dispatch(types.BACKGROUND_ICON, 'users');
            if(this.userRoles.length == 0){
                this.$store.dispatch(types.USER_ROLES,{});       
            }         
        },  
        beforeDestroy(){
                this.$store.dispatch(types.BACKGROUND_ICON, null);
        },
        components:{
            VWidget,
            DdAvatar,
            TopInfoPanel,
            Notification
        }                
    }
</script>

<style scoped>

</style>